module.exports = __webpack_public_path__ + "files/efaf6a02da9e3184538ab500c14a1b68.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/ppt.png
// module id = 582
// module chunks = 60